import {createElement, Component, PropTypes} from 'rlink-react';
import StringInput from './StringInput';


export default class TextInput extends StringInput {
  get inputType () {
    return 'text';
  }

}



// WEBPACK FOOTER //
// ./lib/rlink-forms/inputs/TextInput.jsx